import { createSlice } from "@reduxjs/toolkit";
const initialState = {
  gridRecords: {
    gridRows: [],
  },
};
const BatchSettingReducer = createSlice({
  name: "Nach",
  initialState: initialState,
  reducers: {
    updateGridRows(state, action) {
      state.gridRecords.gridRows = action.payload;
    },
  },
});
export const BatchSettingReducerAction = BatchSettingReducer.actions;
export default BatchSettingReducer.reducer;
